module.exports = __webpack_public_path__ + "media/images/android-chrome-192x192-0c8ca7cf28522fa8297d3cf04c0c423b.png";